'use strict'

class BroadcastScheduleCtrl {

  constructor (zoomFactor, $scope, $http, $mdDialog, moment, Broadcast, $timeout, $rootScope, $state, $location, wsEvents) {

    // Dependencies
    this.$scope = $scope
    this.$http = $http
    this.$mdDialog = $mdDialog
    this.$moment = moment
    this.$timeout = $timeout
    this.$rootScope = $rootScope
    this.$state = $state
    this.$location = $location
    this._Broadcast = Broadcast

    // Properties
    this.loaded = false
    this.data = []
    this.zoomFactor = zoomFactor
    this.zoomFactorDebounce = null
    this.scroll_to = null
    this.refresh = false
    this.waitForCreate = null
    this.waitForUpdate = {}
    this.waitForUpdateCB = {}
    this.oldWeek = {}
    this.urlData = null
    this.uid = null

    this.masterStations = {}

    this.hours = this.generateHours()

    this.$http.get(`print/templates_epg`).then(response => {
      this.epgInfo = response.data
    })

    this.fetch(this.getUrlDate())

    if (window.CONFIG.masterstation_namespaces) {
      let masterstationData = window.CONFIG.masterstation_namespaces
      if (Object.keys(masterstationData).length > 0) {
        for (let key in masterstationData) {
          this.masterStations[masterstationData[key].id] = masterstationData[key]
        }
      } else {
        this.masterStations = false
      }
    }

    // Watchers
    $scope.$watch(() => this.zoomFactor, () => {
      $('.TimeTime, .TimeText').css({
        height: ((70 / 100) * this.zoomFactor) + 'px'
      })
    })

    const {
      station_namespace,
    } = window.CONFIG

    const wsBroadcastCreatedEvents = wsEvents(`broadcast.created.${station_namespace}`)
    wsBroadcastCreatedEvents.messageCallback(this.onBroadcastCreatedEvent.bind(this))

    const wsBroadcastUpdatedEvents = wsEvents(`broadcast.updated.${station_namespace}`)
    wsBroadcastUpdatedEvents.messageCallback(this.onBroadcastUpdatedEvent.bind(this))

    const wsBroadcastDeletedEvents = wsEvents(`broadcast.deleted.${station_namespace}`)
    wsBroadcastDeletedEvents.messageCallback(this.onBroadcastDeletedEvent.bind(this))

    $scope.$on('$destroy', () => {
      wsBroadcastCreatedEvents.destroy()
      wsBroadcastUpdatedEvents.destroy()
      wsBroadcastDeletedEvents.destroy()
    })

    $rootScope.$on('epg_current_uid', (event, uid) => {
      // $(`.epg-dragging:not([data-uid="${uid}"])`).remove();
      this.uid = uid
    })

    $rootScope.$on('wait_for_broadcast_update', (event, data) => {
      let id = data.broadcastId || data.repetitionId
      $(`.epg-dragging[data-uid="${this.uid}"]`).attr('data-uid', id)
      this.waitForCreate = id
    })

    $rootScope.$on('remove_broadcast_planning', () => {
      $('.epg-dragging').remove()
    })

    $scope.$on('$locationChangeSuccess', () => {
      if (this.$location.search().date != this.oldWeek) {
        this.fetch(this.getUrlDate())
      }
    })
  }

  onBroadcastCreatedEvent (data) {
    if (!data) return
    const broadcast = data.broadcast
    if (!broadcast) return

    let uid = broadcast.repetition_uid || broadcast.id
    $(`.epg-dragging[data-uid="${uid}"]`).remove()
    if (broadcast.id === this.waitForCreate || broadcast.repitition_uid === this.waitForCreate) {
      this.waitForCreate = null
    }

    if (broadcast.station_id) {
      for (let key in this.masterStations) {
        broadcast.station_name = this.masterStations[key].title
      }
    }

    broadcast.display_start = broadcast.start
    broadcast.display_stop = broadcast.stop
    let mStart = moment.tz(broadcast.start, window.CONFIG.timezone)
    let mStop = moment.tz(broadcast.stop, window.CONFIG.timezone)

    let start = mStart.format('YYYY-MM-DD')
    let stop = mStop.format('YYYY-MM-DD')
    let days = this.data.days

    if (!days[start] && !days[stop]) {
      return
    }

    if (mStop.hours() === 0 && mStop.minutes() === 0) {
      mStop.subtract(1, 'second')
      broadcast.stop = mStop.format('YYYY-MM-DDTHH:mm:ss')
    }
    if (mStart.day() !== mStop.day()) {

      let copy = angular.extend({}, broadcast)

      broadcast.stop = mStop.hours(0).minutes(0).seconds(0).format('YYYY-MM-DDTHH:mm:ss')

      copy.start = mStart.add(1, 'day').hours(0).minutes(0).seconds(0).format('YYYY-MM-DDTHH:mm:ss')

      let day = days[mStop.format('YYYY-MM-DD')]
      if (day) {
        let foundBroadcast = day.broadcasts.find((b) => b.id === copy.id)
        if (foundBroadcast !== undefined) {
          angular.extend(foundBroadcast, copy)
        } else {
          day.broadcasts.push(copy)
        }
      }
    }

    let day = days[start]
    if (day) {
      let foundBroadcast = day.broadcasts.find((b) => b.id === broadcast.id)
      if (foundBroadcast !== undefined) {
        angular.extend(foundBroadcast, broadcast)
      } else {
        day.broadcasts.push(broadcast)
      }
    }

    this.$timeout(() => {
      this.refresh = !this.refresh
    })
  }

  onBroadcastUpdatedEvent (data) {
    if (!data) return
    const broadcast = data.broadcast
    if (!broadcast) return

    if (this.waitForUpdate[broadcast.id]) {
      delete this.waitForUpdate[broadcast.id]
      this.waitForUpdateCB[broadcast.id](true)
      delete this.waitForUpdateCB[broadcast.id]
    }

    broadcast.display_start = broadcast.start
    broadcast.display_stop = broadcast.stop
    let mStart = moment.tz(broadcast.start, window.CONFIG.timezone)
    let mStop = moment.tz(broadcast.stop, window.CONFIG.timezone)

    let start = mStart.format('YYYY-MM-DD')
    let stop = mStop.format('YYYY-MM-DD')
    let days = this.data.days

    if (!days[start] && !days[stop]) {
      return
    }

    for (let day in days) {
      if (!days.hasOwnProperty(day)) continue
      for (let i = 0; i < days[day].broadcasts.length; i++) {
        if (days[day].broadcasts[i].id === broadcast.id) {
          days[day].broadcasts.splice(i, 1)
          break
        }
      }
    }
    if (mStop.hours() === 0 && mStop.minutes() === 0) {
      mStop.subtract(1, 'second')
      broadcast.stop = mStop.format('YYYY-MM-DDTHH:mm:ss')
    }
    if (mStart.day() !== mStop.day()) {

      let copy = angular.extend({}, broadcast)

      broadcast.stop = mStop.hours(0).minutes(0).seconds(0).format('YYYY-MM-DDTHH:mm:ss')

      copy.start = mStart.add(1, 'day').hours(0).minutes(0).seconds(0).format('YYYY-MM-DDTHH:mm:ss')

      days[mStop.format('YYYY-MM-DD')].broadcasts.push(copy)
    }
    if (days[start]) {
      days[start].broadcasts.push(broadcast)
    }

    this.$timeout(() => {
      this.refresh = !this.refresh
    })
  }

  onBroadcastDeletedEvent (data) {
    if (!data) return
    const broadcast = data.broadcast
    if (!broadcast) return

    let start = moment.tz(broadcast.start, window.CONFIG.timezone).format('YYYY-MM-DD')
    let stop = moment.tz(broadcast.stop, window.CONFIG.timezone).format('YYYY-MM-DD')
    let days = this.data.days

    if (!days[start] && !days[stop]) {
      return
    }

    for (let day in days) {
      let broadcasts = days[day].broadcasts
      for (var i = 0; i < broadcasts.length; i++) {
        if (broadcasts[i].id === broadcast.id) {
          broadcasts.splice(i, 1)
          break
        }
      }
    }

    this.$timeout(() => {
      this.refresh = !this.refresh
    })
  }

  findBroadcast (id, key) {
    let days = this.data.days
    if (key) {
      if (!days[key]) {
        return
      }
      let foundBroadcast = days[key].broadcasts.find((b) => b.id == id)
      if (foundBroadcast !== undefined) {
        return foundBroadcast
      }
    } else {
      for (var i = 0, l = days.length; i < l; i++) {
        let foundBroadcast = days[i].broadcasts.find((b) => b.id == id)
        if (foundBroadcast !== undefined) {
          return foundBroadcast
        }
      }
    }
    return false
  }

  concatBroadcasts () {
    let broadcasts = []

    for (let day in this.data.days) {
      broadcasts = broadcasts.concat(this.data.days[day].broadcasts)
    }

    return broadcasts
  }

  getBroadcastById (broadcastId) {
    for (let day in this.data.days) {
      if (this.data.days.hasOwnProperty(day)) {
        let foundBroadcastArray = this.data.days[day].broadcasts
          .filter(broadcast => broadcast.id === broadcastId)
        if (foundBroadcastArray.length !== 0) {
          return foundBroadcastArray[0]
        }
      }
    }
    return null
  }

  onBroadcastResize (id, start, stop, cb, resetBroadcast) {
    let saveObject = { id: id }
    if (start) saveObject.start = start
    if (stop) saveObject.stop = stop

    let broadcast = this.getBroadcastById(id)
    let action = 'itemsDraft'
    let callback = status => {
      if (!status) {
        if (cb) cb(false)
      } else {
        saveObject._action = action
        this._Broadcast.save(saveObject, () => {
          if (cb) cb(true)
        })
      }
    }

    let shouldDisplayMessage = false
    if (start) {
      if (new Date(start) > new Date(broadcast.start)) {
        shouldDisplayMessage = true
      }
    }
    if (stop) {
      if (new Date(stop) < new Date(broadcast.stop)) {
        shouldDisplayMessage = true
      }
    }

    if (shouldDisplayMessage) {
      this.$http.post('broadcasts/get_shorten_broadcast_items_count', saveObject).then(response => {
        if (response.data.items === 0) {
          callback(true)
        } else {
          this.$mdDialog.show({
            controller: 'ShortenBroadcastDialogCtrl',
            templateUrl: 'shortenBroadcastDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
            locals: {
              count: response.data
            }
          }).then(useAction => {
            action = useAction
            callback(true)
          }).catch(() => callback(false))
        }
      })
    } else {
      callback(true)
    }
  }

  onBroadcastDrop (id, oldStart, newStart, cb) {
    if (!id) return cb(false)
    if (oldStart) {
      let oldStartUTC = moment.tz(oldStart.format('YYYY-MM-DDTHH:mm:ss'), 'utc')
      let newStartUTC = moment.tz(newStart, 'utc')
      if (oldStartUTC.format('YYYY-MM-DDTHH:00:00') === newStartUTC.format('YYYY-MM-DDTHH:00:00')) {
        return this.broadcastMove(id, newStart, cb, 'moveItems')
      }
    }

    this.multiDeleteWarning([id]).then(response => {

      if (
        response.data.removing.items === 0 &&
        response.data.removing_past.items === 0
      ) {
        return this.broadcastMove(id, newStart, cb, 'deleteItems')
      }

      this.$mdDialog.show({
        controller: 'MoveBlockDialogCtrl',
        templateUrl: 'moveBlockDialog.ngTemplate',
        parent: angular.element(document.querySelector('#popupContainer')),
        clickOutsideToClose: true,
        locals: {
          count: response.data,
          option: null
        }
      }).then(action => {
        this.broadcastMove(id, newStart, cb, action)
      }).catch(() => cb(false))
    })
  }

  broadcastMove (id, newStart, cb, moveAction) {
    if (!id) return cb(false)
    this.$http.post('/broadcasts/movetodate/' + id, {
      start: newStart,
      action: moveAction,
    }).then((response) => {
      this.waitForUpdate[id] = true
      this.waitForUpdateCB[id] = cb
    }).catch(err => {
      console.error(err)
      cb(false)
    })
  }

  multiDeleteWarning (ids) {
    return this.$http.post('multideletewarning', { model: 'broadcast', ids: ids })
  }

  onBroadcastBulkDelete (ids) {
    this.multiDeleteWarning(ids).then((response) => {
      this.$mdDialog.show({
        controller: 'ConfirmManyDialogCtrl',
        templateUrl: 'confirmManyDialog.ngTemplate',
        parent: angular.element(document.querySelector('#popupContainer')),
        clickOutsideToClose: true,
        locals: {
          count: response.data,
          option: null
        }
      }).then(() => {
        for (let day in this.data.days) {
          this.data.days[day].broadcasts = this.data.days[day].broadcasts.filter((b) => ids.indexOf(b.id) === -1)
        }
        this.refresh = !this.refresh

        this.$http.post('/broadcasts/bulkdestroy', {
          ids: ids,
        })
      })
    })

  }

  onBroadcastBulkPublish (ids, publish) {

    this.concatBroadcasts()
      .filter((b) => ids.indexOf(b.id) > -1)
      .forEach((b) => b.published = publish)
    this.refresh = !this.refresh

    this.$http.post('/broadcasts/' + (publish ? 'publish' : 'unpublish'), {
      ids: ids,
    })
  }

  onBroadcastBulkPasteCut (ids, pastedDate) {
    this.$http.post('/broadcasts/bulkcut', {
      ids: ids,
      date: pastedDate,
    })
  }

  onBroadcastBulkPasteCopy (ids, pastedDate) {
    this.$http.post('/broadcasts/bulkcopy', {
      ids: ids,
      date: pastedDate,
    })
  }

  fetch (url = null) {
    if (!url) {
      url = '/broadcasts/week/' + this.$moment().format('YYYY-MM-DD')
      this.setUrlDate(this.$moment().format('YYYY-MM-DD'))
    } else {
      let urlArr = url.split('/')
      this.setUrlDate(urlArr[3])
    }

    this.loaded = false
    this.$http.get(url).then((response) => {
      this.data = response.data

      this.date = new Date(this.data.start)
      this.loaded = true

      this.$timeout(() => {
        this.$http.get('/stationsettings/settings/epg_scroll_to', { cache: true }).then((response) => {
          this.scroll_to = response.data
        })

        $('.TimeText').css({
          height: ((70 / 100) * this.zoomFactor) + 'px'
        })

        this.refresh = !this.refresh
      })
    })
  }

  pickDate () {
    let date = this.$moment(this.date)
    let url = '/broadcasts/week/' + date.format('YYYY-MM-DD')
    this.fetch(url)
  }

  saveZoomFactor () {
    if (this.zoomFactorDebounce) {
      clearTimeout(this.zoomFactorDebounce)
    }
    this.zoomFactorDebounce = setTimeout(() => {
      this.$http.post('/usersettings', {
        zoomFactor: this.zoomFactor
      })
    }, 1000)
  }

  createEmptyBroadcast () {
    this.$state.go('epg.create')
  }

  print (templateId) {
    //Open the printpage in a new tab using an anchor with rel='noopener'
    //Else the new tab will use the same renderer as the original page and window.print() will freeze the rundown
    //This seems to be the only workaround for this, source:
    //https://bugs.chromium.org/p/chromium/issues/detail?id=178931

    let body = document.body
    let anchor = document.createElement('a')
    let csrf = document.querySelector('meta[name=\'csrf-token\']').getAttribute('content')

    anchor.href = `print/broadcastsofweektemplate/${this.data.start}/${templateId}?_token=${csrf}`
    anchor.target = '_blank'
    anchor.rel = 'noopener'
    body.appendChild(anchor)
    anchor.click()
    body.removeChild(anchor)
  }

  info () {
    this.$mdDialog.show({
      controller: 'epgInfoDialogCtrl',
      templateUrl: 'epgInfoDialog.ngTemplate',
      parent: angular.element(document.querySelector('#popupContainer')),
      clickOutsideToClose: true,
      locals: {
        urlData: this.urlData
      }
    })
  }

  // Get 24 hours
  generateHours () {

    var hours = []

    for (let i = 0; i < 24; i++) {

      let format = (i < 10) ? '0' + i : i

      format += ':00'

      hours.push(format)
    }

    return hours
  }

  getUrlDate () {
    let url = '/broadcasts/week/'
    let urlDate = this.$location.search()['date']

    if (!urlDate) {
      return null
    }

    return url + urlDate
  }

  setUrlDate (date) {
    this.$location.search('date', date)
    this.oldWeek = date
    this.urlData = date
  }

}

BroadcastScheduleCtrl.$inject = ['zoomFactor', '$scope', '$http', '$mdDialog', 'moment', 'Broadcast', '$timeout', '$rootScope', '$state', '$location', 'wsEvents']

module.exports = BroadcastScheduleCtrl
